import type { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { Api, clearTokens, queryClient, queryKeys, storage } from '@frontend/shared';

import { constants } from '../../constants';

let _extranetApi: Api | null = null;

const getFreshTokens = async (): Promise<string | null> => {
  const fromCache = queryClient.getQueryData<LoginOutput>(queryKeys.tokens());
  if (fromCache?.accessToken) {
    return fromCache.accessToken;
  }
  const fromStorage = storage.getJSONItem<LoginOutput>('tokens');
  return fromStorage?.accessToken ?? null;
};

export const getExtranetApi = (): Api => {
  if (!_extranetApi) {
    _extranetApi = new Api(constants.extranetApi || '', getFreshTokens, () => clearTokens(queryClient));
  }
  return _extranetApi;
};
